import React, { createContext, useContext, useEffect, useState } from "react";
import { tr } from "@/data/translations";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: (key) => key,
});

const readInitialLang = () => {
  if (typeof window === "undefined") return "en";
  // 1) URL ?lang=es wins (so hreflang alternates work for crawlers + shares)
  const params = new URLSearchParams(window.location.search);
  const fromUrl = params.get("lang");
  if (fromUrl === "en" || fromUrl === "es") return fromUrl;
  // 2) Persisted choice
  const stored = window.localStorage.getItem("genesis-lang");
  if (stored === "en" || stored === "es") return stored;
  // 3) Default
  return "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(readInitialLang);

  const setLang = (next) => {
    setLangState(next);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("genesis-lang", next);
    }
  };

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = (key) => tr(lang, key);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
